const ICON_SECTION_COLLAPSED = "cus-control-play-blue";
const ICON_SECTION_EXPANDED = "cus-control-play-blue-down";

/**
 * @method Mixin Soap Content
 * @descriotion all functions used in soap-content and soap-content-locked
 */
export default {
    data() {
        return {
            ICON_SECTION_COLLAPSED: ICON_SECTION_COLLAPSED,
            ICON_SECTION_EXPANDED: ICON_SECTION_EXPANDED,
            labelCol: "col-sm-2",
            selectedValues: null,
            arrowListenerInit: false
        };
    },
    computed: {
        soapDetails() {
            return this.$store.getters["soap/soapDetails"];
        }
    },
    watch: {
        // Not merge yet the soapContent
    },
    mounted() {
        // Init will triggered after the soap content has been rendered from tab-medical-note.vue
    },
    beforeDestroy() {
        this.$root.$off("bv::collapse::state");
    },
    methods: {
        BCollapseEventListener() {
            if (!this.arrowListenerInit) {
                this.$root.$on("bv::collapse::state", (elementId, isShown) => {
                    elementId = elementId.replace("collapse_", "");
                    let arrowElement = document.getElementById(
                        elementId + "_arrow"
                    );
                    if (arrowElement) {
                        if (isShown) {
                            arrowElement.classList.replace(
                                this.ICON_SECTION_COLLAPSED,
                                this.ICON_SECTION_EXPANDED
                            );
                        } else {
                            arrowElement.classList.replace(
                                this.ICON_SECTION_EXPANDED,
                                this.ICON_SECTION_COLLAPSED
                            );
                        }
                    }
                });
                this.arrowListenerInit = true;
            }
        },
        handleMultipleSelectValue(options) {
            let newArray = [];
            if (!options) {
                return newArray;
            }
            if (typeof options === "object") {
                if (Object.prototype.hasOwnProperty.call(options, "")) {
                    // if key is an empty array, we can assume there is no value selected in multiple selection, usally for a new section.
                    return newArray;
                }
                $.each(options, function (key, value) {
                    // push new entry to newArray with key and value
                    newArray.push({
                        id: key,
                        label: value
                    });
                });
                return newArray;
            } else {
                return options;
            }
        }
    }
};
